import { deliveryStatusEnum } from '../../../../core/api/generated/models/DeliveryStatus';
import type { ThreadMessage } from '../../models/conversation-view.types';

export interface DeliveryIndicator {
  glyph: string;
  tone: 'muted' | 'accent' | 'tomato';
  failed: boolean;
}

/** Delivery indicator for an outbound message, or null for inbound/system messages. */
export function deliveryIndicator(message: ThreadMessage): DeliveryIndicator | null {
  if (message.sender !== 'agent') {
    return null;
  }
  // `sendState` is local-only (the optimistic bubble while a send is in flight this session);
  // `deliveryStatus === 'failed'` is the server-persisted terminal state — checked too, so a
  // blocked/failed send still shows the warning after a reload, not just during the live session.
  if (message.sendState === 'failed' || message.deliveryStatus === deliveryStatusEnum.failed) {
    return { glyph: '⚠', tone: 'tomato', failed: true };
  }
  if (message.sendState === 'sending' || message.deliveryStatus === deliveryStatusEnum.pending) {
    return { glyph: '🕓', tone: 'muted', failed: false };
  }
  switch (message.deliveryStatus) {
    case deliveryStatusEnum.sent:
      return { glyph: '✓', tone: 'muted', failed: false };
    case deliveryStatusEnum.delivered:
      return { glyph: '✓✓', tone: 'muted', failed: false };
    case deliveryStatusEnum.read:
      return { glyph: '✓✓', tone: 'accent', failed: false };
    default:
      return null;
  }
}
